var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Closures"},[_c('div',{staticClass:"reportBasic-subTitle"},[_vm._v("\n    "+_vm._s(_vm.$tc('lang.factoryReport.Operation_Records'))+"\n  ")]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.factoryReport.Tax_Bill_Recent_Month')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.closures.freportTaxbill,"otherData":{
          mediaName: '近3个月纳税申报表',
          mediaType: 3,
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: 'freportTaxbill',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.factoryReport.Rent_Records')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.closures.freportRentrecords,"otherData":{
          mediaName: '近3个月房租缴纳凭证',
          mediaType: 3,
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: 'freportRentrecords',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.factoryReport.Utility_bills')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.closures.freportUtilitybills,"otherData":{
          mediaName: '近3个月水电缴纳凭证',
          mediaType: 3,
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: 'freportUtilitybills',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.factoryReport.Material_Input_Invoices')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.closures.freportInputinvoices,"otherData":{
          mediaName: '近6个月原料进项发票',
          mediaType: 3,
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: 'freportInputinvoices',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.factoryReport.Output_Invoices')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.closures.freportOutputinvoices,"otherData":{
          mediaName: '近6个月销项发票',
          mediaType: 3,
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: 'freportOutputinvoices',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.factoryReport.Material_Warehouse_Records')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.closures.freportMaterialrecords,"otherData":{
          mediaName: '原料仓库进出货记录',
          mediaType: 3,
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: 'freportMaterialrecords',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.factoryReport.Product_Warehouse_Records')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.closures.freportProductrecords,"otherData":{
          mediaName: '成品仓库进出货记录',
          mediaType: 3,
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: 'freportProductrecords',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.factoryReport.Bill_of_Material')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.closures.freportBillmaterial,"otherData":{
          mediaName: '产品BOM物料清单',
          mediaType: 3,
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: 'freportBillmaterial',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.factoryReport.Production_Plan')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.closures.freportProductionplan,"otherData":{
          mediaName: '生产计划单',
          mediaType: 3,
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: 'freportProductionplan',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.factoryReport.Production_Summary')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.closures.freportProductionsummary,"otherData":{
          mediaName: '生产报表',
          mediaType: 3,
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: 'freportProductionsummary',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.factoryReport.Inspection_Records')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.closures.freportInspectionrecords,"otherData":{
          mediaName: '品质检验记录',
          mediaType: 3,
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: 'freportInspectionrecords',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.factoryReport.The_factory_failed')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.closures.freportNotdocument,"otherData":{
          mediaName: '工厂未能提供文件资料清单',
          mediaType: 3,
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: 'freportNotdocument',
        },"id":_vm.id}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }